/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UsageDetails {
    getFixupPrototypeFunction() { return UsageDetails.fixupPrototype; }

    static newInstance(model: Partial<UsageDetails>): UsageDetails {
        let obj = Object.assign(new UsageDetails(), model);
        UsageDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UsageDetails>): UsageDetails {
        if (!model) return null;
        return UsageDetails.newInstance(<UsageDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UsageDetails) {
        if (!obj) return;

        models.UsageDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UsageDetails): boolean {
        Object.setPrototypeOf(obj, UsageDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.reserved_hours === undefined) {
            this.reserved_hours = 0;
        }
        if (this.avg_percentage === undefined) {
            this.avg_percentage = 0;
        }
        if (this.used_hours === undefined) {
            this.used_hours = 0;
        }
        if (this.unused_hours === undefined) {
            this.unused_hours = 0;
        }
    }

    /**
     * How many hours are reserved
     */
    reserved_hours: number;

    /**
     * Average Percentage used
     */
    avg_percentage: number;

    /**
     * How many hours are used
     */
    used_hours: number;

    /**
     * How many hours are unused
     */
    unused_hours: number;

}
